// --------------------------------------------------------
// src/helpers/extension.js
//
// This file contains usefull global functions, custom methods 
// for third party libraries and polyfills.
// - String
// - Siema
// - Backbone
// - Underscore
// - jQuery
//
// --------------------------------------------------------

/*
   * Generate an array of letters from two char
   *
   * @param Char chA
   * @param Char chZ
   * @return Array
   */
function genCharArray(chA, chZ) {
	// Get the char code of A and Z
	var a = [], i = chA.charCodeAt(0), j = chZ.charCodeAt(0);
	// Fill the array with the converted char code
	for(; i <= j; i++) {
		a.push(String.fromCharCode(i));
	}
	return a;
}
/**
   * Determine whether a variable is empty
   * Inspired from PHP's empty function
   * http://php.net/manual/en/function.empty.php
   *
   * @var mixed func
   * @return bool
   */
function empty(func) {
	return func === ""     ||
           func === 0      ||
           func === "0"    ||
           func == null   ||
           func === false  ||
           func === []     ||
           typeof(func) === "undefined";
}

// Overwrites the default toString method for Objects
Object.prototype.toString = function () {
	return this.name;
};

// Returns a string with its first character in lowercase
String.prototype.lcfirst = function() {
	var f = this.charAt(0).toLowerCase();
	return f + this.substr(1);
};
// Returns a string with its first character in uppercase
String.prototype.ucfirst = function() {
	var f = this.charAt(0).toUpperCase();
	return f + this.substr(1);
};

// Add a pagination mechanism to the Siema library
Siema.prototype.addPagination = function() {
	var self = this;
	var paginator = new SiemaPaginator({ parent: $(".banner-container"), paginator: self });
	// We listen to the slide changes of the banner and move the indicator to the correct position
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function() {
			var slide = self.currentSlide;
			if(slide !== paginator.currentPos)
			{
				// Move the indicator
				paginator.move(slide);
			}
		});
	});

	// We set the observer to listen to the divs inside the banner
	var target = document.querySelector("#banner div");
	observer.observe(target, { attributes: true, attributeFilter: ["style"] });

	return this;
};

// Add arrows pagination mechanism to the Siema library
Siema.prototype.addArrows = function() {
	// Reference to Siema
	let self = this;
	// Add event listeners to the arrows
	$(document).on("click", ".fa-angle-left", function() {
		self.prev();
	});
	$(document).on("click", ".fa-angle-right", function() {
		self.next();
	});
	return this;
};

// Extra methods for Backbone.Model
_.extend(Backbone.Model.prototype, Backbone.Events, {
	// Check if the current object is "empty" or, more precisely, if the
	// object only has the default values
	isDefault: function() {
		return _.isEqual(this.attributes, this.defaults);
	}
});

// Retrieve the values of an object's properties recursively.
_.iterateValues = function(obj, stack, values) {
    if (typeof(obj) === "string") {
        values.push(obj);
    } else {
        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                if (typeof obj[property] === "object") {
                    _.iterateValues(obj[property], stack + "." + property, values);
                } else {
                    values.push(obj[property]);
                }
            }
        }
    }

	return values;
};

// Checks if the elements of an object is empty
_.objIsEmpty = function(obj) {
	return _.values(obj).every(function(value){
		return value === null;
	});
};

// Extra methods for jQuery
$.fn.extend({
	// Animate a dom element using the animate.css library
	animateCss: function (animationName) {
		var animationEnd = "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
		this.addClass("animated " + animationName).one(animationEnd, function() {
			$(this).removeClass("animated " + animationName);
		});
		return this;
	},
	// Animate IN a jQuery object using the CSS animation library
	animateCssIn: function (animationName) {
		$(this).css({ display: "block", opacity: "1", zIndex: "87" });
		var animationEnd = "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
		this.addClass("animated " + animationName).one(animationEnd, function() {
			$(this).removeClass("animated " + animationName);
		});
		return this;
	},
	// Animate OUT a jQuery object using the CSS animation library
	animateCssOut: function (animationName) {
		$(this).css({ opacity: "0", zIndex: "-9999" });
		var animationEnd = "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
		this.addClass("animated " + animationName).one(animationEnd, function() {
			$(this).removeClass("animated " + animationName);
		});
		return this;
	},
	// Remove a CSS property from the style attribute of a jQuery object
	removeStyle: function(style) {
		var search = new RegExp(style + "[^;]+;?", "g");

		return this.each(function(){
			$(this).attr("style", function(i, style) {
				return style.replace(search, "");
			});
		});
	}
});
